module.exports = __webpack_public_path__ + "static/media/B_S02.4ebd2def.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GREEN/B_S02.png
// module id = 92
// module chunks = 0